<template>
    <div class="c-empty">
        <slot name="icon">
        <div class="c-empty-icon" v-if="icon">
                <i  :class="icon" ></i>
        </div>
    </slot>
        <div class="c-empty-description">
            <slot>
                {{ description }}
            </slot>
           
        </div>
    </div>
</template>

<script>
export default {
    props: {
        icon:{
            // 自定义图标,可以是el-icon的图标，也可以是iconfont的图标类名
            type: String,
            default() {
                return 'el-icon-tickets';
            },  
        },
        description: {
            type: String,
            default() {
                let text ='暂无数据'
                if(this.$t){
                    text = this.$t('common.noData')||'暂无数据';
                }
                return text;
            },
        },
    },
};
</script>

<style scoped lang='scss'>
.c-empty {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    text-align: center;
    box-sizing: border-box;
    padding: 40px 20px;
    color: #5e6d82;
    .c-empty-icon {
        margin-bottom: 12px;
    }
    &-description {
        color: #5e6d82;
    }
}
</style>
